/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCreditHistoryLogDto } from '../../models/create-credit-history-log-dto';
import { CreditHistoryLogDto } from '../../models/credit-history-log-dto';

export interface CreditHistoryLogControllerCreate$Params {
      body: CreateCreditHistoryLogDto
}

export function creditHistoryLogControllerCreate(http: HttpClient, rootUrl: string, params: CreditHistoryLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditHistoryLogDto>> {
  const rb = new RequestBuilder(rootUrl, creditHistoryLogControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreditHistoryLogDto>;
    })
  );
}

creditHistoryLogControllerCreate.PATH = '/api/creditHistoryLog';
